import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { cn as d } from "./index.es19.js";
import { Skeleton as a } from "./index.es11.js";
const o = ({ className: t, ...i }) => /* @__PURE__ */ e(
  "div",
  {
    className: d(
      "flex items-center gap-8 py-4 px-8 bg-white rounded-lg border-x-4 border-x-transparent border-b first:border-t border-y-gray-300",
      t
    ),
    "data-testid": "audio-card-loading",
    role: "status",
    "aria-label": "Loading audio card",
    ...i,
    children: [
      /* @__PURE__ */ r(a, { variant: "circular", width: 52, height: 52 }),
      /* @__PURE__ */ e("div", { className: "flex-1 space-y-2", children: [
        /* @__PURE__ */ r(a, { height: 20, width: "100%" }),
        /* @__PURE__ */ r(a, { height: 20, width: "100%" }),
        /* @__PURE__ */ r(a, { height: 20, width: "50%" })
      ] }),
      /* @__PURE__ */ r(a, { variant: "waveform", className: "flex-shrink-0 w-64 flex-2", height: 40 }),
      /* @__PURE__ */ e("div", { className: "flex items-center gap-6 flex-shrink-0", children: [
        /* @__PURE__ */ r(a, { variant: "rectangular", width: 24, height: 24 }),
        /* @__PURE__ */ r(a, { variant: "rectangular", width: 24, height: 24 }),
        /* @__PURE__ */ r(a, { variant: "rectangular", width: 24, height: 24 }),
        /* @__PURE__ */ r(a, { variant: "rectangular", width: 24, height: 24 })
      ] })
    ]
  }
);
export {
  o as AudioCardLoading
};
